import { midYearReviewId } from '@constants';
import { RouteConfig } from 'vue-router';

const marketingRedirectRoutes: Array<RouteConfig> = [
	{
		path: '/midyear',
		name: 'mid-year-review',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		beforeEnter: async (to, from, next) => {
			next({
				name: 'investor-update',
				params: {
					investorUpdateId: midYearReviewId
				}
			});
		}
	}
];

export default marketingRedirectRoutes;
